import {  Box, Rating } from '@mui/material'
import React from 'react'
import { AVATAR } from '../../assets/images'
interface Props{
    content:string,
    name: string,
    subtitle:string,
    expriance?: string,
    image?:string
}
function TestimonialCards({content,name,subtitle,expriance,image}:Props) {
  return (
    <Box display="flex" justifyContent="center" alignItems="stretch" height="100%">
    <div className='shadow-xl shadow-gray-100 bg-white text-black p-6 max-w-sm rounded-md flex flex-col justify-between'>
         <div className='pb-6'>
                <p className='text-primary pb-2'>
                    {/* <Quote size={34}/> */}
              <img src={image? image : AVATAR} alt={name}  className='w-20 h-20 rounded-full object-cover' loading="lazy"/>
                </p>
            <div className='flex gap-1 pb-3 items-center'>
                <Rating defaultValue={5} precision={5} readOnly/>
                <span className='bg-green-100 px-3 text-green-900 py-0.5 rounded-full'>Verified</span>
            </div>
          <p> {content}</p>
         </div>
         <div className='py-2.5 border-t'>
            <h4 className='text-xl font-bold'>{name}</h4>
            <p className='flex gap-1 pt-1.5'><span>{subtitle}</span> {expriance && <span>. {expriance}</span>}</p>
         </div>
    </div>
    </Box>
  )
}

export default TestimonialCards
